import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

function homepageIntro() {
    const intro = document.querySelector('[data-target="homepage-intro"]')

    if (!intro) return

    const tl = gsap.timeline()

    const introTitle = intro.querySelector('[data-target="intro-title"]')
    const homeIntroEls = intro.querySelectorAll(
        '[data-target="homepage-intro-element"]'
    )
    const homeMainTitle = intro.querySelector(
        '[data-target="homepage-main-title"]'
    )
    const homeMainEls = homeMainTitle.querySelectorAll('div')
    const introBlockText = intro.querySelector(
        '[data-target="intro-block-text"]'
    )
    const introCta = intro.querySelector('[data-target="intro_cta_scroll"]')

    const parallaxImg = document.querySelector('[data-target="intro-parallax"]')
    const svg = parallaxImg.querySelector('svg')

    const dist = document.getElementById('Distant')
    const bg = document.getElementById('Background')
    const mg = document.getElementById('Midground')
    const fg = document.getElementById('Foreground')

    introCta.addEventListener('click', (e) => {
        e.preventDefault()

        gsap.to(window, {
            scrollTo: window.innerHeight + 100,
            duration: 3.5,
        })
    })

    // on load animations
    // set SVG groups to their initial position then animate them in
    // animate the intro text & cta in

    gsap.set(dist, {
        y: -60,
    })

    gsap.set(bg, {
        y: -30,
    })

    gsap.set(mg, {
        y: 50,
    })

    gsap.set(fg, {
        y: 70,
    })

    tl.to(parallaxImg, {
        duration: 5,
        autoAlpha: 1,
    })
        .to(
            dist,
            {
                y: 10,
                duration: 4,
                ease: 'power4.inOut',
            },
            '<'
        )
        .to(
            bg,
            {
                y: -30,
                duration: 4,
                ease: 'power4.inOut',
            },
            '<'
        )
        .to(
            mg,
            {
                y: -15,
                duration: 4,
                ease: 'power4.inOut',
            },
            '<'
        )
        .to(
            fg,
            {
                y: -40,
                duration: 4,
                ease: 'power4.inOut',
            },
            '<'
        )
        .to(
            homeMainEls,
            {
                autoAlpha: 1,
                duration: 2,
                stagger: 0.7,
            },
            '<2'
        )
        .to(
            homeIntroEls,
            {
                autoAlpha: 1,
                duration: 1.5,
                stagger: 0.35,
            },
            '>-1.5'
        )

    const scrollTl = gsap.timeline({
        scrollTrigger: {
            trigger: intro,
            start: 'top top',
            end: '+=270%',
            pin: introTitle,
            scrub: 1,
            immediateRender: false,
            anticipatePin: 1,
        },
    })

    scrollTl
        .to(introTitle, {
            autoAlpha: 0,
            duration: 1,
        })
        .to(introBlockText, {
            autoAlpha: 1,
            duration: 1,
        })
        .to(introBlockText, {
            delay: 0.15,
            autoAlpha: 0,
            duration: 1,
        })
        .to(svg, {
            autoAlpha: 0,
            duration: 1,
        })

    const cardTl = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-target="slider-trigger"]',
            start: '-=140% bottom',
            end: '+=220%',
            scrub: true,
        },
    })

    cardTl
        .to(dist, {
            ease: 'power4.inOut',
            y: 20,
            duration: 3,
        })
        .to(
            bg,
            {
                ease: 'power4.inOut',
                y: 30,
                duration: 3,
            },
            '<'
        )
        .to(
            mg,
            {
                y: -100,
                ease: 'power4.inOut',
                duration: 3,
            },
            '<'
        )
        .to(
            fg,
            {
                y: -250,
                ease: 'power4.inOut',
                duration: 3,
            },
            '<'
        )
        .to(
            parallaxImg,
            {
                autoAlpha: 0,
                duration: 3,
            },
            '<'
        )
        .to(parallaxImg.parentElement, {
            position: 'absolute',
        })
}

export default homepageIntro
